import { EvaluationFeedbackItem, EvaluationFeedbackVerdict } from '@/misc/types'

// Wire shapes of POST /api/mco/stay/{id}/evaluated-label/{evaluatedLabel}/feedback

export type EvaluationFeedbackDtoOut = {
  verdict: EvaluationFeedbackVerdict
  comment: string | null
}

export type EvaluationFeedbackDtoIn = {
  id: number
  userName: string
  verdict: EvaluationFeedbackVerdict
  comment: string | null
  createdAt: string
}

export function convertEvaluationFeedbackOut(payload: { verdict: EvaluationFeedbackVerdict, comment: string | null }): EvaluationFeedbackDtoOut {
  return { verdict: payload.verdict, comment: payload.comment }
}

// A feedback just posted is always the connected user's own
export function convertOwnEvaluationFeedbackIn(dto: EvaluationFeedbackDtoIn): EvaluationFeedbackItem {
  return { id: dto.id, userName: dto.userName, verdict: dto.verdict, comment: dto.comment, createdAt: dto.createdAt, isMine: true }
}
